export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const appConfig = useAppConfig()
  
  // Sync primary color from runtime config to app config
  // This ensures both server and client use the same value at runtime
  // Fixes the issue where app.config.ts uses build-time env var replacement
  // but runtimeConfig correctly reads the env var at runtime
  if (runtimeConfig.public.primaryColor) {
    appConfig.ui.colors.primary = runtimeConfig.public.primaryColor
    // Debug: log the color being set (remove in production if needed)
    if (import.meta.dev) {
      console.log('[app-config] Setting primary color to:', runtimeConfig.public.primaryColor)
    }
  }
})

